<template>
  <el-dialog :visible.sync="visible" :width="!showPay ? '880px' : '690px'">
    <div slot="title">
      {{ showPay ? $t('personal::contract::确认支付信息') : $t('personal::contract::选择升级套餐') }}
      <span class="tip">
        {{ showPay ? $t('personal::contract::pay_tip') : $t('personal::contract::upgrade_tip') }}
      </span>
    </div>
    <div class="wrap" v-if="!showPay && list.length">
      <div class="list">
        <div class="contract-wrap" v-for="item in list" :key="item.id">
          <div class="contract-item" @click="chooseContract(item)" :class="[{ active: item.id === selectCombo.id }]">
            <div class="contract-title">
              <span class="mr-8">{{ item.name }}</span>
            </div>
            <div class="contract-price">
              ${{ $dataCheck(item.priceInfo && item.priceInfo.price, 0) }}
              <span>/{{ filterUnit[item.priceInfo && item.priceInfo.cycleUnit] }}</span>
            </div>
            <div class="contract-desc">
              <p
                v-for="(re, index) in item.remark.split('\n')"
                :key="index"
                :class="{ smallcontent: item.id === lastContracts.id ? index != 0 : false }"
              >
                {{ re }}
              </p>
            </div>
            <transition name="el-fade-in-linear">
              <div class="choose-active" v-show="item.id === selectCombo.id">
                <i class="el-icon-check"></i>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <default-data
      :custom="{
        text: $t('personal::contract::暂无可升级套餐'),
        height: '450px',
      }"
      v-else-if="!showPay && !list.length"
    ></default-data>
    <div class="content" v-else>
      <div>{{ $t('personal::contract::content_title') }}：</div>
      <div class="contract-content">
        <div class="contract-name">{{ selectCombo.name }}</div>
        <!-- <div class="contract-remark">{{ selectCombo.remark }}</div> -->
        <div class="contract-detail">
          <p
            v-for="(re, index) in selectCombo.remark.split('\n')"
            :key="index"
            :class="{ smallcontent: selectCombo.id === lastContracts.id ? index != 0 : false }"
          >
            {{ re }}
          </p>
          <!-- <span v-if="selectCombo.shopQuantity">
            {{ $t('personal::contract::站点数') }}：{{ selectCombo.shopQuantity }}个
          </span>
          <span v-if="selectCombo.permissionList.length">
            {{ checkPermission(selectCombo.permissionList) }}
          </span>
          <span v-if="selectCombo.priceInfo.gmvFirstFreeCommission">
            {{ $t('personal::contract::首年免佣额度') }}${{ selectCombo.priceInfo.gmvFirstFreeCommission / 10000 }}w
          </span> -->
        </div>
      </div>
      <div class="pay-content">
        <div class="list-item">
          <span>{{ $t('personal::contract::付款方式') }}</span>
          <span>{{ $t('personal::my-contract::年付') }}</span>
        </div>
        <div class="list-item">
          <span>{{ $t('personal::contract::套餐价格') }}</span>
          <span>${{ selectCombo.priceInfo.price }}/{{ $t('personal::my-contract::年') }}</span>
        </div>
        <div class="list-item" v-show="remainDay">
          <div>
            {{ $t('personal::contract::优惠详情') }}
          </div>
          <span>{{ $t('personal::contract::优惠详情content', { name: detail.comboName, day: remainDay }) }}</span>
        </div>
      </div>
      <div class="count-sum">
        <span>{{ $t('personal::contract::amount') }}</span>
        <span>${{ selectCombo.priceInfo.price }}/{{ $t('personal::my-contract::年') }}</span>
      </div>
      <div class="card-content">
        <div style="font-weight: bold">{{ $t('personal::contract::请选择支付信用卡') }}</div>
        <div class="card-list">
          <div
            class="card-item"
            :class="{ choose: item.id === selectCard.id }"
            @click="chooseCard(item)"
            v-for="item in cardList"
            :key="item.id"
          >
            <img style="height: 20px" :src="filterImg(item.cardBrand)" />
            <span>************* {{ item.cardNum }}</span>
          </div>
          <div class="card-item add-card" @click="isShowAddCard = true">
            <i class="iconfont iconadd"></i>
            {{ $t('personal::open-contract::addOtherCard') }}
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="cancel">
        {{ showPay ? $t('personal::contract::上一步') : $t('system::common::btn::cancel') }}
      </el-button>
      <el-button type="primary" @click.stop="submit" :loading="loading">
        {{ !showPay ? $t('personal::contract::下一步') : $t('system::common::btn::confirm') }}
      </el-button>
    </div>
    <addCard v-model="isShowAddCard" @success="getCards"></addCard>
    <ResultDialog v-model="resultVisible" :result="result"></ResultDialog>
  </el-dialog>
</template>

<script>
import {
  getPackageContract,
  getCardsList,
  getSubscriptionsRemainDay,
  upgradeSubscriptions,
} from '@/server/personal/contract'
import {
  _local,
} from '@/utils/storage';
import { filterUnit, payTypeMap, filterImg } from '../config'
import addCard from './addCard.vue'
import ResultDialog from './result.vue'
import Cookies from 'js-cookie'
export default {
  components: { addCard, ResultDialog },
  props: {
    value: {},
    detail: {
      type: Object,
      default: () => {},
    },
    cards: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      payTypeMap,
      visible: false,
      lastContracts: {}, // 特殊处理，最后一个套餐备注样式需要特殊处理
      payType: this.detail.paymentType || 'y',
      contracts: [], // 合约列表
      filterUnit,
      loading: false,
      selectCombo: {}, // 选择套餐
      showPay: false,
      cardList: [], // 绑定信用卡列表
      isShowAddCard: false,
      selectCard: {},
      remainDay: '', // 套餐剩余时间
      resultVisible: false,
      result: {},
    }
  },
  mounted() {},
  computed: {
    list() {
      // 过滤套餐等级小于已购买套餐的套餐
      return this.contracts.length
        ? this.contracts
            .filter(
              item =>
                item.priceList.find(i => i.cycleUnit === this.payType) &&
                item.grade >= Number(this.detail.grade) &&
                this.detail.comboId !== item.id
            )
            .sort((a, b) => Number(a.sortWeight) - Number(b.sortWeight))
        : []
    },
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible(val) {
      this.$emit('input', val)
      if (val) {
        this.cardList = [...this.cards]
        this.getPackage()
        this.getSubscriptionsRemainDay()
        this.selectCombo = {}
        this.selectCard = {}
      } else {
        this.showPay = false
      }
    },
  },
  methods: {
    filterImg,
    checkPermission(list) {
      if (list.some(el => el.systemId === 2) && list.some(el => el.systemId === 3)) {
        return this.$t('personal::contract::送店铺和BI')
      } else if (list.some(el => el.systemId === 2)) {
        return this.$t('personal::contract::送店铺')
      } else if (list.some(el => el.systemId === 3)) {
        return this.$t('personal::contract::送BI')
      }
    },
    async getSubscriptionsRemainDay() {
      const { data } = await getSubscriptionsRemainDay()
      if (data.code === this.$code) {
        this.remainDay = data.data
      }
    },
    async getPackage() {
      const { data } = await getPackageContract()
      if (data.code === this.$code) {
        this.contracts = data.data || []
        if (this.contracts.length) {
          this.lastContracts = data.data[data.data.length - 1]
        }
        this.filterContracts()
      }
    },
    filterContracts() {
      this.contracts.forEach(item => {
        const info = item.priceList.find(i => i.cycleUnit === this.payType)
        if (info) {
          item.priceInfo = info
        }
      })
    },
    chooseContract(item) {
      this.selectCombo = item
    },
    chooseCard(item) {
      this.selectCard = item
    },
    async getCards() {
      // 绑定新卡后重新请求列表
      const { data } = await getCardsList()
      if (data.code === this.$code) {
        this.cardList = data.data || []
      }
    },
    async submit() {
      if (!Object.keys(this.selectCombo).length) {
        this.$message.error(this.$t('personal::contract::请选择升级套餐'))
        return
      }
      if (!this.showPay) {
        this.showPay = true
        return
      }
      if (!Object.keys(this.selectCard).length) {
        this.$message.error(this.$t('personal::contract::请选择支付信用卡'))
        return
      }
      this.resultVisible = true
      this.result = {
        close: false,
        iconClass: 'el-icon-loading',
        resultTitle: this.$t('personal::contract::loading'),
        resultTips: this.$t('personal::contract::loadingTip'),
      }
      const { data } = await upgradeSubscriptions({
        platform: 1,
        priceId: this.selectCombo.priceInfo.id,
        payMethod: this.selectCard.id,
      })

      if (data.code === this.$code) {
        this.result = {
          close: true,
          iconClass: 'el-icon-success',
          resultTitle: this.$t('personal::contract::success'),
          resultTips: this.$t('personal::contract::successTip'),
          buttons: [
            {
              text: this.$t('personal::contract::前往建站'),
              click: () => {
                let url =
                  `${_local.get('BITOSHOPLINK') || process.env.VUE_APP_SHOP_URL}?name=${this.$store.state.user.userName}&token=${Cookies.get('saasToken')}`
                if (Cookies.get('preAccount')) {
                  url = url + `&preAccount=${Cookies.get('preAccount')}`
                }
                setTimeout(() => {
                  window.location.href = url
                }, 500)
              },
            },
            {
              text: this.$t('personal::contract::订单详情'),
              click: () => {
                this.visible = false
                this.resultVisible = false
                this.$emit('success')
              },
            },
          ],
        }
      } else {
        this.result = {
          close: true,
          iconClass: 'el-icon-error',
          resultTitle: this.$t('personal::contract::error'),
          resultTips: this.$t('personal::contract::errorTip'),
          buttons: [
            {
              text: this.$t('personal::contract::重新支付'),
              click: () => {
                this.resultVisible = false
              },
            },
          ],
        }
      }
    },
    cancel() {
      if (this.showPay) {
        this.showPay = false
      } else {
        this.visible = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tip {
  font-size: 12px;
  color: #999;
}
.wrap {
  height: 466px;
  overflow: auto;
  background: #eff2f5;
  border-radius: 6px;
  .list {
    padding: 16px;
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-around;
    margin: 0 -24px -24px 0px;
    .contract-item {
      margin-bottom: 24px;
      margin-right: 24px;
      &.disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
      position: relative;
      width: 252px;
      height: 350px;
      padding: 24px;
      background: #ffffff;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      cursor: pointer;
      border: 1px solid transparent;
      box-sizing: border-box;
      &.contract-item-collapse {
        width: 342px;
        height: 476px;
      }
      &.active {
        border: 1px solid #0560fd;
      }
      &:hover {
        box-shadow: 0px 2px 20px 0px rgba(59, 43, 43, 0.1);
      }
      .contract-title {
        font-size: 18px;
        font-weight: bold;
        color: #010517;
        .has-subscribe {
          display: inline-block;
          width: 52px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          background: #0560fd;
          border-radius: 2px;
          font-size: 12px;
          font-weight: bold;
          color: #ffffff;
          white-space: nowrap;
        }
      }
      .contract-price {
        font-size: 20px;
        font-weight: bold;
        color: #0560fd;
        margin: 16px 0;
        span {
          font-size: 12px;
          font-weight: normal;
        }
      }
      .contract-desc {
        flex: 1;
        position: relative;
        padding: 16px;
        background: #f9f9f9;
        border-radius: 8px;
        color: #666;
        p {
          font-size: 14px;
          line-height: 32px;
          white-space: normal;
          text-align: start;
        }
        .smallcontent {
          font-size: 12px;
          line-height: 28px;
          color: #666;
        }
      }
      .choose-active {
        position: absolute;
        top: -1px;
        right: -1px;
        border-top-right-radius: 4px;
        width: 0;
        height: 0;
        border-width: 22.5px;
        border-style: solid;
        border-color: #0560fd #0560fd transparent transparent;
        .el-icon-check {
          position: absolute;
          top: -20px;
          left: 2px;
          font-size: 16px;
          color: #fff;
        }
      }
    }
  }
}
.content {
  .contract-content {
    margin-top: 16px;
    margin-bottom: 24px;
    padding: 30px;
    background: #fbfbfb;
    border-radius: 4px;
    border: 1px solid #efefef;
    .contract-name {
      font-size: 16px;
      font-weight: bold;
    }
    .contract-remark {
      margin-top: 10px;
      color: #8f9092;
    }
    .contract-detail {
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      line-height: 28px;
      font-size: 12px;
      .smallcontent {
        font-size: 12px;
        line-height: 28px;
        color: #666;
      }
    }
  }
  .pay-content {
    margin-bottom: 24px;
    .list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .list-item + .list-item {
      margin-top: 16px;
    }
  }
  .count-sum {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 0;
    border-top: 1px solid #f0f0f0;
    border-bottom: 8px solid #f9f9f9;
  }
}
.card-content {
  margin-top: 24px;
}
.card-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 16px;
  .card-item {
    width: 43%;
    padding: 18px 14px;
    border: 1px solid #eeeeee;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #010517;
    margin-bottom: 16px;
    &.choose {
      border: 1px solid #0560fd;
    }
    &.add-card {
      color: #0560fd;
      .iconadd {
        font-size: 17px;
        color: #0560fd;
        margin-right: 10px;
      }
    }
  }
}
</style>
